import React from 'react';
import CopyrightText from "../footer/copyright_text";

const Footer = () => (
  <footer className="standalone-footer" style={{ marginBottom: '-60px' }}>
    <div className="container">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <p className="copy text-left copy-inline">
          <CopyrightText/>
        </p>
        <img
          className="right-position"
          src={require('images/powered_by_sh_140x32w.png')}
          alt="Powered by SchoolHire"
        />
      </div>
    </div>
  </footer>
);

export default Footer;
